export default __webpack_public_path__ + "assets/images/f2c3f49029a8fe8daf60fdaca256f6b2.png";